import { useState, useEffect } from 'react'
import { Alert, Table, Button  } from 'reactstrap'
import { handleGraphQLErrors } from '../../utils'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner.js'
import { GET_OPEN_FILES_LIST_QUERY } from '../../graphql.js'

export const GET_OPEN_FILES_LIST = gql(GET_OPEN_FILES_LIST_QUERY)

export default function OpenFilesList(props) {
  console.log('OpenFilesList rendered: ', props)

  const [showSpinner, setShowSpinner] = useState(false)
  const [openFilesList, setopenFilesList] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [refresh, setRefresh] = useState(0)

  useEffect(() => {
    async function fetchItems() {
      console.log('OpenFilesList.useEffect.fetchItems')
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: GET_OPEN_FILES_LIST })
        if (data.getOpenFilesList) {
          console.log(data.getOpenFilesList)
          setopenFilesList(data.getOpenFilesList[0].files)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    fetchItems()
  }, [refresh])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (openFilesList) {
    const rows = []
    let count = 0
    for (let file of openFilesList) {
      count++
      rows.push(<tr key={count}><td>{count}</td><td style={{ textAlign: 'left' }}>{file.type}</td><td style={{ textAlign: 'left'}}>{file.name}</td></tr>)
    }
    return (
      <div style={{ textAlign: 'center', height: '100%', overflow: 'auto', padding: '10px' }}>
        <div style={{ textAlign: 'center', padding: '10pxs' }}>
          <Button color="primary" style={{ marginBottom: '10px' }} onClick={() => setRefresh(refresh + 1)}>Refresh</Button>
          <div><span style={{ fontWeight: 'bold'}}>Total Files: </span><span>{openFilesList.length}</span></div>
          <Table bordered size="sm" style={{ width: 'auto', margin: 'auto' }}>
            <thead>
              <tr>
                <th></th>
                <th>Type</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
  return ''
}
